import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "question-label question-label-project2"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_9 = ["src", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.classes?.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", {
            class: _normalizeClass(["sm:col-span-6 main-content", _ctx.config.classes?.mainClasses])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.config.classes?.textsWrapper)
            }, [
              (_ctx.config.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _withDirectives(_createElementVNode("span", null, null, 512), [
                      [_directive_t, _ctx.config.title]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.config.textPart1)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: "mt-4",
                    innerHTML: _ctx.$rt(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_4))
                : _createCommentVNode("", true),
              (_ctx.config.textPart2)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 2,
                    class: "mt-4",
                    innerHTML: _ctx.$t(_ctx.config.textPart2, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_5))
                : _createCommentVNode("", true),
              (_ctx.config.textPart3)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 3,
                    class: "mt-4",
                    innerHTML: _ctx.$t(_ctx.config.textPart3, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true),
              (_ctx.config.textPart4)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 4,
                    class: "mt-4",
                    innerHTML: _ctx.$t(_ctx.config.textPart4, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_7))
                : _createCommentVNode("", true)
            ], 2),
            (_ctx.config.images)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.images, (image, index) => {
                    return (_openBlock(), _createElementBlock("img", {
                      class: _normalizeClass([{'border-b-4 border-project': _ctx.selectedImages[index]}, "m-4 p-2 cursor-pointer max-w-14 inline"]),
                      key: index,
                      src: image,
                      onClick: ($event: any) => (_ctx.selectImage(index, image))
                    }, null, 10, _hoisted_9))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_BackNextButtons, {
              "button-class": "action-button action-button-project2 mt-12 mb-8",
              "go-to": _ctx.goTo,
              "next-screen": _ctx.config.screenNext
            }, null, 8, ["go-to", "next-screen"])
          ], 2),
          (_ctx.config.bgImage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["col-span-2 h-full min-h-75vh flex-col items-center flex", _ctx.config.classes.rightSide]),
                style: _normalizeStyle(`background-image: ${_ctx.config.bgImage}; background-size: contain; background-position: center; background-repeat: no-repeat; ${_ctx.config.bgStyles}`)
              }, null, 6))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}